<template>
  <div class="home-content-page-v" style="width:100%;">
    <div class="gu-duan">
      <el-select v-model="car_first" placeholder="请选择车辆类型">
        <el-option v-for="item in cars" :key="item" :label="item" :value="item">
        </el-option>
      </el-select>
    </div>
    <div class="two-content">
      <div class="content-1">
        <mii-table :datas="oneCarRoutes" :table_style="3" :one_row="true" :ths="ths2" title="车辆配送线路"></mii-table>
      </div>
      <div class="content-2">
        <div class="content-column-1">
          <content-title title="结果报告"></content-title>
          <div class="result-content">
            <div class="result-one">
              <span>总成本</span><div>{{solutionData['总成本']}} 元</div>
            </div>
            <div class="result-one">
              <span>车辆数量</span><div>{{solutionData['车辆数量']}} 辆</div>
            </div>
            <div class="result-one">
              <span>订单数量</span><div>{{solutionData['订单数量']}} 单</div>
            </div>
            <div class="result-one">
              <span>配送订单数量</span><div>{{solutionData['配送订单数量']}} 单</div>
            </div>
            <div class="result-one">
              <span>未配送订单数量</span><div>{{solutionData['未配送订单数量']}} 单</div>
            </div>
          </div>
        </div>
        <div class="m-line">
        </div>
        <div class="content-column-1">
          <content-title title="车辆容量利用"></content-title>
          <div class="car-content">
            <div class="car-content-1">
              <el-select v-model="car2" placeholder="请选择车辆类型">
                <el-option v-for="item in cars" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="car-content-1">
              <echarts chart_id="car-echart" :style="echartsOption.outOption.style" :option="echartsOption.option"></echarts>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="display:none">
      {{carRoutes.length}}
    </div>
  </div>
</template>

<script>
  import MiiTable from '../components_bit/MiiTable'
  import ContentTitle from '../components_bit/ContentTitle'
  import Echarts from '@/components/Echarts'
  import {
    initOption
  } from '@/EchartsOptions'

  export default {
    name: 'cars',
    components: {
      ContentTitle,
      MiiTable,
      Echarts
    },
    computed: {
      sourceDataType: {
        get () {
          return this.$store.getters.sourceDataType
        }
      },
      carRoutes: {
        get () {
          return this.$store.getters.carRoutes
        }
      },
      solutionData: {
        get () {
          return this.$store.getters.solutionData
        }
      },
      echartsOption: {
        get () {
          let echartsOption = {
            option: {},
            outOption: {
              style: ''
            }
          }
          let showDatas = {
            car: this.car2,
            data: [{
              'value1': this.sourceDataType !== 'shop' ? '0号柴油' : '干货',
              'value2': 0
            },
            {
              'value1': this.sourceDataType !== 'shop' ? '92号汽油' : '新鲜货',
              'value2': 0
            },
            {
              'value1': this.sourceDataType !== 'shop' ? '95号汽油' : '冰冻货',
              'value2': 0
            }]
          }
          if (this.car2) {
            let customers = []
            let vm = this
            this.clusterCutomer.forEach(function (item) {
              if (item[0].slice(2) === vm.car2.slice(2)) {
                customers = item.slice(1)
              }
            })
            this.orderWeight.forEach(function (item) {
              if (customers.indexOf(item.shop) > -1) {
                showDatas.data[0]['value2'] += item.Fresh
                showDatas.data[1]['value2'] += item.dry
                showDatas.data[2]['value2'] += item.frozen
              }
            })
            console.log(showDatas)
            echartsOption = {option: initOption(showDatas.data, this.option), outOption: {style: this.option.style}}
          }
          return echartsOption
        }
      },
      clusterCutomer: {
        get () {
          return this.$store.getters.clusterCutomer
        }
      },
      orderWeight: {
        get () {
          return this.$store.getters.orderWeight
        }
      },
      cars: {
        get () {
          this.car_first = this.car_first || this.$store.getters.cars[0]
          this.car2 = this.car2 || this.$store.getters.cars[0]
          return this.$store.getters.cars
        }
      },
      oneCarRoutes: {
        get () {
          let data = []
          let vm = this
          this.carRoutes.forEach(function (item) {
            if (item.car === vm.car_first) {
              item.route_data.forEach(function (one) {
                data.push({'route': one[0] + '<i class="iconfont icon-jiantou"></i>' + one[1]})
              })
            }
          })
          return data
        }
      }
    },
    data () {
      return {
        car_first: '',
        car2: '',
        option: {
          chartType: 'huan',
          dataX: 'value1',
          dataY: 'value2',
          otherOption: {
            title: ''
          },
          style: ''
        },
        ths2: [{
          key: 'route'
        }]
      }
    }
  }
</script>
<style lang="less">
  .two-content .el-select .el-input .el-input__icon {
    background: #081633;
    color: #fff;
    width: 5em;
    transition: none;
  }
  .two-content .el-input__icon+.el-input__inner {
    padding-left: 2.3em;
  }
</style>

<style scoped lang="less">
  @import '../style/base.less';
  .two-content {
    display: flex;
  }
  .car-content {
    flex:1;
    display: flex;
  }
  .result-content {
    flex: 1;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
    padding: 1.8em 2.2em,

  }
  .result-one {
    display: flex;
    flex: 1;
    justify-content: space-between;
    font-size: 1em;
    color: @bak-color-1;
    span {
      width: 30%;
    }
    div {
      width: 30%;
      display: flex;
      justify-content: left;
    }
  }

  .gu-duan {
    margin: 0 0 1.2em;
    width: 100%;
    .el-select {
      width: 25em;
    }
  }
  .setting-content {
    .content-shadow;
    .content-bottom-radius;
    padding: 2.2em;
    display: flex;
    background-color: #fff;
    justify-content: space-between;
  }
  .model-setting {
    width: 31em;
    display: flex;
    flex-direction: column;
  }
  .content-column-1 {
    .content-shadow;
    .content-radius;
    width: 50em;
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #fff;
  }
  .one-model-setting {
    margin-bottom: 2.2em;
    justify-content: space-between;
    align-items: center;
    display: flex;
    span {
      font-size: 1em;
      color: @bak-color-1;
    }
    input:focus {
      outline:none;
    }
    input {
      margin-left: 2em;
      border: 1px solid #999;
      border-radius: 3px;
      padding: 2px;
      width: 14em;
      font-size: 1.13em;
      background-color: rgba(0, 0,0,0)
    }
  }
  .content-1 {
    width: 40em;
    margin-right: 3em;
  }
  .content-2 {
    height: 39.5em;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .car-echart {
    flex: 1;
  }
  .car-content-1 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }
  .one-model-last {
    margin-bottom: 0em;
  }
  .checkbox-content {
    padding: 1.38em 2.2em;
    display: flex;
    flex-direction: column;
    span {
      line-height: 1;
      font-size: 0.8em;
      color: @bak-color-2;
    }
  }
  .m-line {
    height: 2.5em;
    width: 100%;
  }
  .setting-note {
    padding-right: 2em;
    width:50em;
    line-height: 2;
    color: @bak-color-2;
    font-size: 0.88em;
  }
  .checkbox-one {
    display: flex;
    align-items: center;
    height: 2.5em;
    font-size: 1em;
    color:@bak-color-1;
    img {
      padding: 0 1em;
    }
  }
</style>



// WEBPACK FOOTER //
// car_route.vue?fa4c9fbe